import React, { useState, useEffect, useCallback } from 'react';
import CustomTable from '../ui/customTable';
import Services from '../services/services';
import BodyContainer from '../ui/BodyContainer';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { getUserBrowserStorage } from '../constants';
import { useHistory, useLocation } from 'react-router-dom';
import { backArrow } from '../ui/icons';

const useStyles = makeStyles((theme) => ({
  gridOccupy: {
    width: '100%',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
  },
}));

function EventInvitees() {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [backendRes, setBackendRes] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const localUserDetails = JSON.parse(getUserBrowserStorage('userDetails'));
  const eventData = location.state.data;

  const columns = [
    { field: 'id', headerName: 'S.No:', width: 130 },
    { field: 'fullName', headerName: 'Name', width: 200 },
    { field: 'email', headerName: 'Email Id', width: 250 },
  ];

  const getEventInvitees = async () => {
    try {
      const res = await Services.list_of_invitees(
        localUserDetails.userId,
        eventData.eventId
      );
      const userDetailsRes = res.data.userDetails;
      // setUserDetails(userDetailsRes);
      setBackendRes(userDetailsRes);
    } catch (error) {}
  };

  const createData = useCallback((backendRes) => {
    const dataToTable = backendRes.map((item, index) => {
      const x = {
        id: index + 1,
        fullName: item.firstName + ' ' + (item.lastName || ''),
        email: item.email,
      };
      return x;
    });
    // setTableBody(dataToTable);
    return dataToTable;
  }, []);

  useEffect(() => {
    const formattedList = createData(backendRes);
    setUserDetails(formattedList);
  }, [backendRes, createData]);

  useEffect(() => {
    getEventInvitees();
  }, []);

  const handleBackButton = () => {
    history.goBack();
  };
  // const icon = (
  //   <ArrowBackIosIcon
  //     onClick= {handleBackButton}
  //     style={{cursor: 'pointer'}}
  //   />
  // );

  return (
    <BodyContainer title="Event Invitees" icon={backArrow(handleBackButton)}>
      <Grid className={classes.gridOccupy}>
        <Paper elevation={0} className={classes.root}>
          {userDetails.length ? (
            <CustomTable listData={userDetails} columns={columns} />
          ) : (
            <Typography style={{ alignSelf: 'flex-start' }}>
              No invitees to display
            </Typography>
          )}
        </Paper>
      </Grid>
    </BodyContainer>
  );
}

export default EventInvitees;
